import { _animate } from "../utils/_animate";
import { _backgroundGradient } from "../utils/_backgroundGradient";
import { _fibonacci } from "../utils/_fibonacci";
import { _lazyLoad } from "../utils/_lazyLoad";
import { _parallax } from "../utils/_parallax";
import { _section } from "../utils/_section";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

export const _homePageUniforms = {
    colorSize: 0.8, // size of the other colors than main bg color
    colorSpacing: 0.33, // other colors gap to each other
    colorRotation: 2, // gradient's rotation, 0 = 0deg,
    colorSpread: 10, // other color spread size
    colorOffset: [-0.9, -0.7],

    transformPosition: [-2, 0],
    zoom: 0.5,
};

class Masthead extends MainClass {
    background: _backgroundGradient | null;

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.background = null;

        this.init();
    }

    init() {
        // for fibonacci line
        const _fibonacciType = this.selector.dataset.fibonacci ? parseFloat(this.selector.dataset.fibonacci) : 1;
        new _fibonacci({
            target: this.selector,
            type: _fibonacciType,
            events: {
                init: (instance) => {
                    instance.el.title = this.selector.querySelector(".js-splittext");
                },
                resize: (instance) => {
                    if (instance.type === 2) {
                        const _titleOffset = _parallax.getOffset(instance.el.title);

                        instance.el.center.style.left =
                            window.innerWidth >= 810 ? `${_titleOffset.left + instance.el.title.offsetWidth}px` : "";
                    }
                },
            },
        });

        // for bg-gradient
        if (!_section.bodyGradient())
            this.background = new _backgroundGradient({
                target: document.body,
                uniforms: _homePageUniforms,
            });

        // for lazyload
        _lazyLoad();

        // for intro animation
        new _animate();
    }
}

export default Masthead;
